/** @format */
'use strict';

window.addEventListener("DOMContentLoaded", () => {
    /**
     * Makes a request to submit the form input to the specified endpoint
     */
    function submitForm(formElem) {
        const responseElem = formElem.closest('.c-mailing-signup').querySelector('.c-mailing-signup__response');
        const endpoint = `${wpApiSettings.root}v1/tessitura/signup/`;
        const options = {
            method: "POST",
            headers: {
                'X-WP-Nonce': wpApiSettings.nonce
            },
            body: new FormData(formElem),
        };

        responseElem.innerHTML = '';
        responseElem.classList.remove('success', 'error');

        fetch(endpoint, options)
            .then(response => response.json())
            .then(res => {
                responseElem.innerHTML = res.data.response
                if (res.success) {
                    responseElem.classList.add('success')
                } else {
                    responseElem.classList.add('error')
                    let err = new Error("HTTP status code: " + res.status)
                    err.response = res
                    err.status = res.status
                    throw err
                }
            })
            .catch(error => console.error('Any issue when submitting the registration form:', error));
    }

    const mailingSignUpForms = document.querySelectorAll('.c-mailing-signup-form');
    if (mailingSignUpForms.length) {
        mailingSignUpForms.forEach(form => {
            form.addEventListener("submit", event => {
                event.preventDefault()
                submitForm(event.currentTarget)
            })
        })
    }
})
